import { getFavorites, onFavoritesChange } from '@theme/favorites-store';

/**
 * <s-fav-count> shows the number of saved favorites (used beside the FAVORIETEN menu tab).
 * Hidden while the list is empty. data-label holds the accessible text with "__N__" as the count.
 */
class SFavCount extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    onFavoritesChange((list) => this.#render(list.length), this.#ac.signal);
    this.#render(getFavorites().length);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #render(count) {
    this.hidden = count === 0;
    this.textContent = String(count);
    const label = this.dataset.label;
    if (label) this.setAttribute('aria-label', label.replace('__N__', String(count)));
  }
}

if (!customElements.get('s-fav-count')) customElements.define('s-fav-count', SFavCount);
